import { jsxs, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Divider } from "@perxis-auto/ui-kit/lib/components/Divider";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Switch } from "@perxis-auto/ui-kit/lib/components/Switch";
import { Typography } from "@perxis-auto/ui-kit/lib/components/Typography";
import clsx from "clsx";
import styles from "./ComparisonSpecifications.module.scss.js";
const ComparisonSpecifications = memo(function ComparisonSpecifications2({
  items,
  isShowDifference,
  hasVehicles,
  onShowDifferenceChange,
  t,
  className,
  ...props
}) {
  if (!hasVehicles) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Row, { className: clsx(styles.comparisonSpecifications, className), ...props, children: [
    /* @__PURE__ */ jsx(Col, { span: 24, className: styles.comparisonSpecifications__header, children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-yellow"], justify: "space-between", align: "middle", children: [
      /* @__PURE__ */ jsx(Col, { sm: { flex: "none", order: 1 }, xs: { span: 24, order: 2 }, children: /* @__PURE__ */ jsx(Typography.Title, { level: "h3", className: styles.comparisonSpecifications__title, children: t("widgets.comparisonSpecifications.title") }) }),
      /* @__PURE__ */ jsx(Col, { sm: { flex: "none", order: 2 }, xs: { span: 24, order: 1 }, children: /* @__PURE__ */ jsx(
        Switch,
        {
          checked: isShowDifference,
          onChange: onShowDifferenceChange,
          label: t("widgets.comparisonSpecifications.switchLabel")
        }
      ) })
    ] }) }),
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Divider, { width: "thick", color: "dark" }) }),
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Row, { gutter: [0, "vertical-sky"], children: items.map((specs, specsGroupIndex) => {
      var _a, _b;
      if (!specs.length) {
        return null;
      }
      const specGroupId = ((_a = specs.find((spec) => !!(spec == null ? void 0 : spec.id))) == null ? void 0 : _a.id) || 0;
      const specGroupLabel = ((_b = specs.find((spec) => !!(spec == null ? void 0 : spec.label))) == null ? void 0 : _b.label) || "";
      const specGroupKey = `${specGroupId}-${specsGroupIndex}`;
      return /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], children: [
        /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(
          Typography.Text,
          {
            level: "main",
            color: "dark-light",
            className: styles.comparisonSpecifications__specGroupLabel,
            children: specGroupLabel
          }
        ) }),
        /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx("div", { className: styles.comparisonSpecifications__row, children: specs.map((spec, specIndex) => {
          const specId = (spec == null ? void 0 : spec.id) || 0;
          const specKey = `${specId}-${specIndex}`;
          return /* @__PURE__ */ jsx(
            Typography.Text,
            {
              level: "main",
              color: "darkest",
              className: styles.comparisonSpecifications__specGroupValue,
              children: (spec == null ? void 0 : spec.value) ?? "—"
            },
            specKey
          );
        }) }) })
      ] }) }, specGroupKey);
    }) }) })
  ] });
});
export {
  ComparisonSpecifications
};
